import React from 'react';
import classNames from 'classnames';
import {
  FDBodyText,
  FDPaper,
  FDStack,
  FDTable,
  FDTableBody,
  FDTableCell,
  FDTableHead,
  FDTableRow,
  FDTitleText,
} from '@facet-wealth/design';
import { GuidedHouseholdReviewDateTableLineItemLayout } from 'Components/UI/guidedHouseholdReview/dateTableLineItem';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { buildBaseOverrides } from 'Components/UI/guidedHouseholdReview/baseOverrides';

const useStyles = buildUseStyles('GuidedHouseholdReviewDateTableSection', (theme) => ({
  rowBackgroundColor: {
    '& th': { // all th elements below
      backgroundColor: theme.palette.common.white,
    },
  },
}));

export const GuidedHouseholdReviewDateTableSection = ({ outlined }) => {
  const classes = useStyles();
  const { resource } = useMetaLayoutContext();

  const dataLineItemOverrideSet = buildBaseOverrides()
    .nameOverride(['name', 'amountWithFrequency', 'startType', 'startAtAge', 'startDate', 'endType', 'endDate', 'endAtAge'], {
      _component: () => FDBodyText,
    }, overrideReadOnly);

  const lineItems = resource.attr('lineItems').resources().list();
  if (lineItems.length === 0) {
    return null;
  }

  const headline = lineItems[0];
  const nonHeadlineLineItems = lineItems.slice(1);
  const headlineText = headline.attr('name');

  if (nonHeadlineLineItems.length === 0) {
    return (
      <FDPaper padding={outlined ? 3 : 0} appearance={outlined ? 'outlined' : 'flat'}>
        <FDStack direction="column" spacing={1}>
          <FDTitleText value={headlineText} />
          <FDBodyText value={`No ${headlineText.toLowerCase()}.`} />
        </FDStack>
      </FDPaper>
    );
  }

  return (
    <FDPaper padding={outlined ? 3 : 0} appearance={outlined ? 'outlined' : 'flat'}>
      <div className={classNames(classes.rowBackgroundColor)}>
        <FDTable size="sm">
          <FDTableHead>
            <FDTableRow>
              <FDTableCell>{headlineText}</FDTableCell>
              <FDTableCell>Amount</FDTableCell>
              <FDTableCell>Start date</FDTableCell>
              <FDTableCell>End date</FDTableCell>
            </FDTableRow>
          </FDTableHead>
          <FDTableBody>
            {nonHeadlineLineItems.map((lineItem) => (
              <MetaResourceRenderer
                key={resource.id()}
                layout={GuidedHouseholdReviewDateTableLineItemLayout}
                metaOverrideSet={dataLineItemOverrideSet}
                resource={lineItem}
              />
            ))}
          </FDTableBody>
        </FDTable>
      </div>
    </FDPaper>
  );
};
